module.exports = __webpack_public_path__ + "img/hplc-cloud-logo@6x.7e9ef4b3.png";